import { useState, useEffect } from 'react';
import { ComboBox, Inline } from '@airbus/components-react';
import { ChangesWarningDialog } from '../../../shared/components/grid/viewManager/ViewsList';
import { useColumnContextAPI } from '../../../shared/context/GetAllColumnContext';
import { getAllScreenGridFeatures } from '../../features_access/services/getAllScreenGridFeatures';
import { useConfigContext } from '../../../shared/context/ConfigContext';
import { getAllScreenGridAttributes } from '../services/getScreenGridAttributes';

export default function HeaderScreenList(props) {
  const {
    updateValue,
    screenOptions,
    initialValue,
    rows,
    gridOptions,
    updateGridValue,
    initialGridValue,
    screen,
  } = props;
  const [options, setOptions] = useState([]);
  const [screenGridOptions, setScreenGridOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [selectedGrid, setGridSelected] = useState(null);
  const [previousSelected, setPreviousSelected] = useState(null);
  const [previousGridSelected, setPreviousGridSelected] = useState(null);
  const { updateCustomConfig, setAllDropdowns, allDropdowns } = useColumnContextAPI();
  const { configSchema } = useConfigContext();
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const ddOptions = [
    { label: 'Update', value: 'U' },
    { label: 'Hide', value: 'H' },
  ];

  useEffect(() => {
    const initialOption = screenOptions?.find((item) => item.value === initialValue) ?? null;
    const secondOption = gridOptions?.find((item) => item.value === initialGridValue) ?? null;
    setOptions(() => screenOptions);
    setScreenGridOptions(() => gridOptions);
    setSelected(() => initialOption);
    setGridSelected(() => secondOption);
    setPreviousSelected(() => initialOption);
    setPreviousGridSelected(() => secondOption);
  }, [screenOptions, gridOptions, initialValue, initialGridValue]);

  useEffect(() => {
    const fetchData = async () => {
      if (screen === 'featureAccess' && selectedGrid) {
        const res = await getAllScreenGridFeatures(selectedGrid?.value, configSchema);
        setAllDropdowns({
          ...allDropdowns,
          screen_grid_feature_id: res[`${configSchema}_v_screen_grid_feature`],
        });
      } else if (screen === 'attributeAccess' && selectedGrid) {
        const res = await getAllScreenGridAttributes(selectedGrid?.value, configSchema);
        setAllDropdowns({
          ...allDropdowns,
          screen_grid_attr_config_id: res[`${configSchema}_v_screen_grid_attribute`],
          access_level: ddOptions
        });
      }
    };
    fetchData();
  }, [selectedGrid]);

  useEffect(() => {
    if (screen === 'screenAccess' && selected) {
      updateCustomConfig({
        AdditionalFilterQuery: `screen_id:{_eq:${selected?.value}}`,
      });
    }
  }, [selected]);

  useEffect(() => {
    if (selectedGrid) {
      updateCustomConfig({
        AdditionalFilterQuery: `screen_grid_id:{_eq:${selectedGrid?.value}}`,
      });
    }
  }, [allDropdowns]);

  const handleScreenChange = (option) => {
    if (!option?.value) {
      return;
    }
    setSelected(() => option);
    const filterRows = rows.filter(({ status }) => status === 'E');
    if (filterRows.length) {
      setIsWarningOpen(() => true);
      return;
    }
    setPreviousSelected(() => option);
    updateValue(option.value);
  };

  const handleGridChange = (option) => {
    if (!option?.value) {
      return;
    }
    setGridSelected(() => option);
    const filterRows = rows.filter(({ status }) => status === 'E');
    if (filterRows.length) {
      setIsWarningOpen(() => true);
      return;
    }
    setPreviousGridSelected(() => option);
    updateGridValue(option.value);
  };

  const cancelHandler = () => {
    setIsWarningOpen(() => false);
    setSelected(previousSelected);
    setGridSelected(previousGridSelected);
  };
  const warnDiagOkHandler = () => {
    setIsWarningOpen(() => false);
    updateValue(selected.value);
    updateGridValue(selectedGrid.value);
  };

  return (
    <Inline alignY='center' align='center' spacing='2-x'>
      <div className='w-250'>
        <ComboBox
          className='listbox'
          value={selected}
          onChange={(obj) => handleScreenChange(obj)}
          id='combo-box-demo'
          options={options}
          size='medium'
          keepInputOnSelect
          hideClear
        />
      </div>
      {screenGridOptions && (
        <div className='w-250'>
          <ComboBox
            className='listbox'
            value={selectedGrid}
            onChange={(obj) => handleGridChange(obj)}
            id='combo-box-demo'
            options={screenGridOptions}
            size='medium'
            keepInputOnSelect
            hideClear
          />
        </div>
      )}
      <ChangesWarningDialog
        {...{ isOpen: isWarningOpen, cancelHandler, okHandler: warnDiagOkHandler }}
      />
    </Inline>
  );
}
